module.exports = __webpack_public_path__ + "93e442a035a9ef88549ae21fe50ecfad.svg";